import React from 'react'
import {Spin} from "antd"
import ReportCallDetailHead from "./ReportCallDetailHead"
import ReportCallDetailBody from "./ReportCallDetailBody"

const ReportCallDetailTable = (props) => {
    const {loading, error, listReports} = props

    return (
        <div className="CustomersTable">
            <Spin spinning={loading} tip="Đang dữ liệu từ server">
                <table>
                    <ReportCallDetailHead/>
                    <ReportCallDetailBody error={error} listReports={listReports}/>
                </table>
            </Spin>
        </div>
    )
}

export default ReportCallDetailTable
